import * as React from "react";
import { Root, createRoot } from "react-dom/client";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { LS2ThemeProvider } from "./Theme";
import { LanguageProvider } from "./Language";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CssBaseline } from "@mui/material";
import { LocationConfigurationProvider } from "./LocationConfiguration";
import { AccountProvider } from "./Account";
import { ToastProvider } from "@tlc/ui/toast";
import { SupportedFunctionalityProvider } from "./SupportedFunctionality";
import { getDayJSLocale } from "@tlc/ui/localization/getDayJSLocale";
import { ErrorDialogProvider } from "@tlc/ui/dialog/error/ErrorDialogContext";
import { DialogRegistryProvider } from "@tlc/ui/dialog/DialogRegistry";

// TODO move to ls2kids source folder

const sharedCssCache = createCache({
  key: "css",
});

/**
 * @deprecated used by ls2kids only, refactor for specific kids cases
 */
export function renderWithoutShadow(
  children: React.JSX.Element,
  container: Element,
): Root | null {
  if (!container) {
    console.error("renderWithoutShadow requires a valid container element");
    console.trace();
    return;
  }

  const root = createRoot(container);

  root.render(
    <CacheProvider value={sharedCssCache}>
      <CssBaseline />
      <DialogRegistryProvider>
        <LanguageProvider>
          <ErrorDialogProvider>
            <LocationConfigurationProvider>
              <LS2ThemeProvider isKids={true}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={getDayJSLocale()}
                >
                  <ToastProvider>
                    <SupportedFunctionalityProvider>
                      <AccountProvider>{children}</AccountProvider>
                    </SupportedFunctionalityProvider>
                  </ToastProvider>
                </LocalizationProvider>
              </LS2ThemeProvider>
            </LocationConfigurationProvider>
          </ErrorDialogProvider>
        </LanguageProvider>
      </DialogRegistryProvider>
    </CacheProvider>,
  );

  return root;
}
